<div class="layout horizontal center middle" style="width: 100%; height: 120px; margin-bottom: 16px;">
    <app-flipping-logo height="120px" 
                       width="120px"
                       frontImage="./assets/images/login.svg"
                       frontImageHeight="100px">
    </app-flipping-logo>
</div>
<ng-container *ngIf="!submitDone">
<p [innerHtml]="'SIGN_UP.PASSWORD_REQUIREMENTS'|translate: { allowedSpecialCharacters: passwordAllowedSpecialCharactersAsStr } "></p>
<app-form-field #passowrdFormField type="PASSWORD" [label]="'SIGN_UP.NEW_PASSWORD'|translate"
                [settings]="settings.fieldsSettings.password"
                [value]="valuesForInput.password"
                (modelChange)="updateCurrentValue('password',$event)"
                [specifiedAttributes]="specifiedAttributes.password"
                (enterPressure)="submit()">
</app-form-field>
<app-form-field #passowrdFormField type="PASSWORD" [label]="'SIGN_UP.CONFIRM_NEW_PASSWORD'|translate"
                [settings]="settings.fieldsSettings.passwordConfirmation"
                [value]="valuesForInput.passwordConfirmation"
                (modelChange)="updateCurrentValue('passwordConfirmation',$event)"
                [specifiedAttributes]="specifiedAttributes.passwordConfirmation"
                (enterPressure)="submit()">
</app-form-field>

<div class="layout horizontal space-between middle">
    <app-button [label]="'CANCEL'|translate" icon="arrow-left" (click)="cancel()" [disabled]="formSubmitting"></app-button>
    <app-button [label]="'SIGN_UP.CONFIRM'|translate" primary="true" icon="check" (click)="submit()" [disabled]="someErrors || formSubmitting"></app-button>
</div> 
</ng-container>
